var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.48135 9.45327C1.69133 8.07572 1.30987 6.95087 1.07986 5.81065C0.739685 4.12428 1.51818 2.47697 2.80782 1.42586C3.35287 0.981621 3.97769 1.1334 4.3 1.71163L5.02765 3.01706C5.60441 4.05177 5.89279 4.56913 5.83559 5.11763C5.77839 5.66613 5.38947 6.11285 4.61165 7.00631L2.48135 9.45327ZM2.48135 9.45327C4.08042 12.2415 6.58986 14.7524 9.38137 16.3533M9.38137 16.3533C10.7589 17.1433 11.8838 17.5248 13.024 17.7548C14.7104 18.0949 16.3577 17.3165 17.4088 16.0268C17.853 15.4818 17.7012 14.8569 17.123 14.5346L15.8176 13.807C14.7829 13.2302 14.2655 12.9419 13.717 12.9991C13.1685 13.0562 12.7218 13.4452 11.8283 14.223L9.38137 16.3533Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a8fd967d5ec8d7d33c1d59ddbdc3a207.svg";
export { ForwardRef as ReactComponent };